/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { LocationInstance } from "../models/location-instance";
import { LocationService } from "../services/location.service";
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { PAGING_ITEMS_PER_PAGE } from "../app-constants";
import { PagedResults } from "app/models/paged-results";

/**
 * Resolver used to obtain Locations in the background on a page transistion.
 * The # of Locations returned can be configured using "locationsPerPage" route data. 
 */
@Injectable()
export class LocationInstancesPagingResolver implements Resolve<PagedResults<LocationInstance>> {

  constructor(
    private locationService: LocationService
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<LocationInstance>> {
    // Get the # of Locations to have in the page being obtained
    let numberOfLocations: number = route.data['locationsPerPage'];
    if (numberOfLocations == null || numberOfLocations < 1) {
      numberOfLocations = PAGING_ITEMS_PER_PAGE;
    }
    
    try {
      return await this.locationService.getAllLocationInstancesForPaging(0, numberOfLocations, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Location Instances!", error);
    }
  }

}
